/* Fichier HD : composition du texte et de la décoration à la taille d'impression.
   Le même code produit l'aperçu (petite largeur) et les calques envoyés au relais (largeur d'impression) ;
   le relais pose les calques sur le fichier d'origine recadré au format choisi.
   Dépend de shop-config.js (CELESTIAR_CONFIG.FORMATS).
   Polices : Cormorant Lining = Cormorant Garamond dont les chiffres par défaut sont les chiffres alignés
   (lnum + tnum), comme sur le site ; le canvas ne sait pas activer ces options lui-même. */
(function () {
  var FONT = '"Cormorant Lining", "Cormorant Garamond", "Times New Roman", serif';
  var ALL = ['13x18', '20x25', 'a4', '30x40', '40x50', '50x70', '60x90', '70x100'];
  var MASTER_W = 7087, MASTER_H = 10630;      /* taille des fichiers d'origine, en pixels */

  /* Décoration de chaque design, mesurée sur tes fichiers d'origine. Unités : millièmes de la largeur de l'affiche
     (y = distance depuis le haut, d = distance depuis le bas), donc la décoration suit les bords de tous les formats. */
  var GOLD = 'rgb(214,190,140)';
  var DESIGNS = {
    'aurore-boreale': { kind: 'celeste', formats: ALL, deco: {
      top: [{ y: 65.5, t: 2, c: 'rgb(205,190,150)' }, { y: 78, t: 4.5, c: 'rgb(212,184,120)' }, { y: 91, t: 2, c: 'rgb(205,190,150)' }],
      bottom: [{ d: 48.5, t: 2, c: 'rgb(205,190,150)' }, { d: 35, t: 4.5, c: 'rgb(212,184,120)' }, { d: 22, t: 2, c: 'rgb(205,190,150)' }],
      sideLines: [{ x: 3.5, k: 1.5, c: 'rgb(200,185,150)', y0: 91, d1: 22 }], title: { cy: 130, w: 309, c: 'rgb(220,200,155)' } } },
    'etoiles-celestes': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 62, r: 62, t: 88, b: 76, k: 2.6, c: 'rgb(232,220,193)' }, { l: 70.5, r: 70.5, t: 97.5, b: 85.5, k: 1.8, c: 'rgb(232,220,193)' }],
      title: { cy: 173, w: 442, c: 'rgb(226,206,160)' } } },
    'voie-lactee': { kind: 'celeste', formats: ALL, deco: {
      top: [{ y: 33, t: 2, c: 'rgb(200,180,135)' }, { y: 45.5, t: 4.2, c: 'rgb(222,204,160)' }, { y: 59.5, t: 2, c: 'rgb(200,180,135)' }],
      bottom: [{ d: 39, t: 2.2, c: 'rgb(185,160,118)' }, { d: 25.5, t: 4.5, c: 'rgb(198,168,118)' }, { d: 12.5, t: 2.2, c: 'rgb(185,160,118)' }],
      title: { cy: 125, w: 454, c: 'rgb(226,208,162)' } } },
    'etoiles-filantes': { kind: 'celeste', formats: ALL, deco: {
      top: [{ y: 44.5, t: 7, c: 'rgb(225,190,124)' }, { y: 63.5, t: 2.6, c: 'rgb(205,178,146)' }],
      bottom: [{ d: 44, t: 2.3, c: 'rgb(186,157,132)' }, { d: 24.5, t: 7, c: 'rgb(198,157,100)' }],
      title: { cy: 115, w: 309, c: 'rgb(214,192,163)' } } },
    'etoile-des-voeux': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 8, r: 8, t: 8, b: 8, k: 1.2, c: 'rgba(190,190,198,.8)' }, { l: 27, r: 27, t: 27, b: 27, k: 2.6, c: 'rgb(200,175,130)' }, { l: 36, r: 36, t: 36, b: 36, k: 1.2, c: 'rgba(205,195,185,.85)' }],
      title: { cy: 54, w: 349, c: '#d6c4a0' } } },
    'infini-celeste': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(226,200,160)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(226,200,160)' }],
      title: { cy: 78, w: 300, c: 'rgb(226,200,160)' } } },
    'deux-lunes': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(228,214,184)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(228,214,184)' }],
      title: { cy: 78, w: 300, c: 'rgb(228,214,184)' } } },
    'alliance-celeste': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(226,200,150)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(226,200,150)' }],
      title: { cy: 78, w: 300, c: 'rgb(226,200,150)' } } },
    'arche-des-etoiles': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(226,205,160)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(226,205,160)' }],
      title: { cy: 78, w: 300, c: 'rgb(226,205,160)' } } },
    'berceau-de-lune': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(224,198,150)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(224,198,150)' }],
      title: { cy: 78, w: 300, c: 'rgb(224,198,150)' } } },
    'premiere-lumiere': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(224,198,150)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(224,198,150)' }],
      title: { cy: 78, w: 300, c: 'rgb(224,198,150)' } } },
    'coeur-de-galaxie': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(240,198,190)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(240,198,190)' }],
      title: { cy: 78, w: 300, c: 'rgb(240,198,190)' } } },
    'fleche-d-etoiles': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(240,204,190)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(240,204,190)' }],
      title: { cy: 78, w: 300, c: 'rgb(240,204,190)' } } },
    'sapin-celeste': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(226,200,150)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(226,200,150)' }],
      title: { cy: 78, w: 300, c: 'rgb(226,200,150)' } } },
    'etoile-du-berger': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(230,206,150)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(230,206,150)' }],
      title: { cy: 78, w: 300, c: 'rgb(230,206,150)' } } },
    'cadeau-d-etoiles': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(232,206,160)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(232,206,160)' }],
      title: { cy: 78, w: 300, c: 'rgb(232,206,160)' } } },
    'feu-d-artifice-celeste': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(232,206,160)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(232,206,160)' }],
      title: { cy: 78, w: 300, c: 'rgb(232,206,160)' } } },
    'la-haut-une-etoile': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(224,230,240)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(224,230,240)' }],
      title: { cy: 78, w: 300, c: 'rgb(224,230,240)' } } },
    'colombe-celeste': { kind: 'celeste', formats: ALL, deco: {
      frames: [{ l: 34, r: 34, t: 34, b: 34, k: 1.5, c: 'rgb(224,230,240)' }, { l: 46, r: 46, t: 46, b: 46, k: 1, c: 'rgb(224,230,240)' }],
      title: { cy: 78, w: 300, c: 'rgb(224,230,240)' } } },
       'nebora':  { kind: 'orbe', title: 'NEBORA',  formats: ALL, ex: { prenom: 'Milo',  date: '8 août 2025',      ville: 'Lyon',      phrase: 'Une étoile est née' },
      color: '#EEF7FF', veil: { from: 0.64, rgba: [2, 10, 31, 0.35] },
      glow: [[0, 0, .35, 'rgba(120,190,255,.95)'], [0, 0, .9, 'rgba(70,140,255,.6)'], [0, .04, .2, 'rgba(2,10,31,.8)']] },
    'luneria': { kind: 'orbe', title: 'LUNÉRIA', formats: ALL, ex: { prenom: 'Louna', date: '15 juin 2024',    ville: 'Marseille', phrase: 'Mon petit miracle' },
      color: '#FFF8FF', veil: { from: 0.66, rgba: [70, 45, 120, 0.22] },
      glow: [[0, 0, .35, 'rgba(225,175,255,.95)'], [0, 0, .9, 'rgba(180,120,255,.6)'], [0, .04, .22, 'rgba(70,40,120,.55)']] },
    'aurelis': { kind: 'orbe', title: 'AURÉLIS', formats: ALL, ex: { prenom: 'Noé',   date: '21 décembre 2024', ville: 'Bordeaux',  phrase: 'Tu as illuminé notre vie' },
      color: '#F7DFA6', veil: { from: 0.64, rgba: [26, 15, 2, 0.4] },
      glow: [[0, 0, .35, 'rgba(255,200,95,.75)'], [0, 0, .9, 'rgba(255,170,60,.4)'], [0, .05, .22, 'rgba(26,15,2,.95)']] }
  };

  /* ---------- utilitaires ---------- */
  function fmt(id) { return (window.CELESTIAR_CONFIG.FORMATS || []).filter(function (f) { return f.id === id; })[0]; }
  var clamp = function (v, lo, hi) { return Math.max(lo, Math.min(hi, v)); };
  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  var fitSize = function (base, minimum, maxChars, text) { return Math.max(minimum, base * Math.min(1, maxChars / Math.max(1, String(text || '').trim().length))); };
  function newCanvas(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function solid(color) { var c = newCanvas(1, 1), x = c.getContext('2d'); x.fillStyle = color; x.fillRect(0, 0, 1, 1); return c; }
  function rect(color, left, top, w, h) { return { canvas: solid(color), left: Math.round(left), top: Math.round(top), w: Math.max(1, Math.round(w)), h: Math.max(1, Math.round(h)) }; }
  function setLS(ctx, px) { if ('letterSpacing' in ctx) ctx.letterSpacing = px + 'px'; }
  function glyphWidth(ctx, text, ls) { var n = 'letterSpacing' in ctx; var w = ctx.measureText(text).width; return n ? w - ls : w + ls * (text.length - 1); }
  function drawRun(ctx, text, x, y, ls) {
    ctx.textAlign = 'left';
    if (('letterSpacing' in ctx) || !ls) { ctx.fillText(text, x, y); return; }
    for (var i = 0; i < text.length; i++) { ctx.fillText(text[i], x, y); x += ctx.measureText(text[i]).width + ls; }
  }
  function wrap(ctx, text, maxW) {
    var words = String(text).split(/\s+/), lines = [], cur = '';
    words.forEach(function (w) { var t = cur ? cur + ' ' + w : w; if (ctx.measureText(t).width <= maxW || !cur) cur = t; else { lines.push(cur); cur = w; } });
    if (cur) lines.push(cur);
    return lines;
  }
  function fontStr(e) { return e.style + ' ' + e.weight + ' ' + e.size + 'px ' + FONT; }
  function gradientLayer(W, top, h, stops) {
    var c = newCanvas(1, 256), x = c.getContext('2d'), g = x.createLinearGradient(0, 0, 0, 256);
    stops.forEach(function (s) { g.addColorStop(s[0], s[1]); });
    x.fillStyle = g; x.fillRect(0, 0, 1, 256);
    return { canvas: c, left: 0, top: Math.round(top), w: W, h: Math.round(h) };
  }

  /* ---------- textes saisis par le client ---------- */
  function dateText(iso, loc) { var d = new Date(iso + 'T12:00:00'); return isNaN(d.getTime()) ? iso : d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' }); }
  function formatFields(raw, locale, design) {
    var loc = locale === 'en' ? 'en-GB' : 'fr-FR', d = DESIGNS[design];
    if (d && d.kind === 'orbe') {
      var ex = d.ex, prenom = cap((raw.prenom || '').trim()), ville = cap((raw.ville || '').trim()), phrase = cap((raw.phrase || '').trim());
      var date = raw.date ? dateText(raw.date, loc) : '';
      var line = [date || ex.date, ville || ex.ville].filter(Boolean).join(' · ');
      return { prenom: prenom || ex.prenom, dateLine: line, phrase: phrase || (prenom ? '' : ex.phrase) };
    }
    var defs = { prenom: 'LÉA', date: '12 mars 2024', heure: '08h42', ville: 'Paris', phrase: 'Le jour où tout a commencé' };
    var v = cap((raw.ville || '').trim()), p = cap((raw.phrase || '').trim());
    var dt = raw.date ? dateText(raw.date, loc) : defs.date, h = raw.heure ? raw.heure.replace(':', 'h') : defs.heure;
    return { prenom: (raw.prenom || '').trim().toUpperCase() || defs.prenom, date: dt + ' · ' + h, ville: v || defs.ville, phrase: p || defs.phrase };
  }

  /* ---------- Instant Céleste : même mise en page que .live-poster ---------- */
  /* Les marges des lignes date / ville / phrase sont écrasées à 0 sur le site (.live-poster__text p { margin: 0 }),
     et le thème impose line-height 1.7 aux paragraphes. */
  function celesteLayout(ctx, W, H, f, draw) {
    var innerW = W * 0.86, cx = W / 2;
    var els = [
      { key: 'prenom', size: fitSize(9, 4.7, 10, f.prenom) * W / 100, weight: 600, style: 'normal', color: '#ecd9a0', spacing: 0.2, lh: 1.1 },
      { key: 'date',   size: fitSize(3.6, 2.2, 24, f.date) * W / 100, weight: 400, style: 'normal', color: '#e8d9ae', spacing: 0, lh: 1.7 },
      { key: 'ville',  size: fitSize(3.4, 2.1, 18, f.ville) * W / 100, weight: 400, style: 'normal', color: '#f0ebdc', spacing: 0, lh: 1.7 },
      { key: 'phrase', size: fitSize(3.4, 2.1, 44, f.phrase) * W / 100, weight: 400, style: 'italic', color: '#f0ebdc', spacing: 0, lh: 1.7 }
    ];
    var y = 0, boxes = [];
    els.forEach(function (e) {
      ctx.font = fontStr(e); setLS(ctx, e.spacing * e.size);
      var m = ctx.measureText('Hgé'), asc = m.fontBoundingBoxAscent, desc = m.fontBoundingBoxDescent, lineH = e.lh * e.size;
      var lines = e.key === 'phrase' ? wrap(ctx, f[e.key], innerW) : [f[e.key]];
      boxes.push({ e: e, lines: lines, top: y, lineH: lineH, baseOffset: (lineH - (asc + desc)) / 2 + asc });
      y += lineH * lines.length;
    });
    var blockTop = H * 0.94 - y;
    if (draw) boxes.forEach(function (b) {
      if (draw.only && draw.only.indexOf(b.e.key) < 0) return;
      ctx.font = fontStr(b.e); ctx.fillStyle = b.e.color; setLS(ctx, b.e.spacing * b.e.size);
      b.lines.forEach(function (line, i) {
        var ls = b.e.spacing * b.e.size, x = cx - glyphWidth(ctx, line, ls) / 2;
        drawRun(ctx, line, x, draw.offsetY + blockTop + b.top + i * b.lineH + b.baseOffset, ls);
      });
    });
    return { blockTop: blockTop, boxes: boxes.map(function (b) { return { key: b.e.key, top: b.top, h: b.lineH * b.lines.length }; }) };
  }
  function celesteLayers(W, H, f, design) {
    var k = W / 1000, pad = Math.ceil(16 * k), out = [], d = DESIGNS[design];
    var vh = Math.round(H * 0.4);
    out.push(gradientLayer(W, H - vh, vh, [[0, 'rgba(8,14,38,0)'], [0.38, 'rgba(8,14,38,.74)'], [1, 'rgba(8,14,38,.92)']]));
    if (d.deco) out = out.concat(decoLayers(W, H, d.deco));
    var geo = celesteLayout(newCanvas(1, 1).getContext('2d'), W, H, f, null);
    [['prenom'], ['date', 'ville', 'phrase']].forEach(function (keys) {
      var bx = geo.boxes.filter(function (b) { return keys.indexOf(b.key) >= 0; });
      var top = Math.min.apply(null, bx.map(function (b) { return b.top; })), bottom = Math.max.apply(null, bx.map(function (b) { return b.top + b.h; }));
      var cv = newCanvas(W, bottom - top + pad * 2), ctx = cv.getContext('2d');
      ctx.textBaseline = 'alphabetic'; ctx.shadowColor = 'rgba(0,0,0,.65)'; ctx.shadowBlur = 8 * k; ctx.shadowOffsetY = 1 * k;
      celesteLayout(ctx, W, H, f, { offsetY: pad - (geo.blockTop + top), only: keys });
      out.push({ canvas: cv, left: 0, top: Math.round(geo.blockTop + top - pad), w: cv.width, h: cv.height });
    });
    return out;
  }
  /* Décoration : regroupée en 4 bandes (haut + titre, bas, gauche, droite) car le relais n'accepte que 10 opérations par image. */
  function decoLayers(W, H, spec) {
    var u = W / 1000, L = [];
    (spec.top || []).forEach(function (l) { L.push(l.y + l.t / 2); });
    (spec.frames || []).forEach(function (f) { L.push(f.t + f.k); });
    var topExt = Math.max.apply(null, L.concat([spec.title ? spec.title.cy + spec.title.w * 0.06 + 10 : 0]));
    var B = [(spec.bottom || []).map(function (l) { return l.d + l.t / 2; }), (spec.frames || []).map(function (f) { return f.b + f.k; })];
    var botExt = Math.max.apply(null, [0].concat(B[0], B[1]));
    var sideExt = Math.max.apply(null, [0].concat((spec.frames || []).map(function (f) { return Math.max(f.l, f.r) + f.k; }), (spec.sideLines || []).map(function (s) { return s.x + s.k; })));
    var T = Math.ceil((topExt + 3) * u), Bt = Math.ceil((botExt + 3) * u), S = Math.ceil((sideExt + 3) * u);
    function fill(x, c, X, Y, w, h) { x.fillStyle = c; x.fillRect(X, Y, Math.max(1, w), Math.max(1, h)); }
    var out = [];
    /* haut */
    var top = newCanvas(W, T), tx = top.getContext('2d');
    (spec.top || []).forEach(function (l) { fill(tx, l.c, 0, (l.y - l.t / 2) * u, W, l.t * u); });
    (spec.frames || []).forEach(function (f) { fill(tx, f.c, f.l * u, f.t * u, W - (f.l + f.r) * u, f.k * u); });
    if (spec.title) titleText(tx, W, spec.title, u);
    out.push({ canvas: top, left: 0, top: 0, w: top.width, h: top.height });
    /* bas */
    if (botExt) {
      var bot = newCanvas(W, Bt), bx = bot.getContext('2d');
      (spec.bottom || []).forEach(function (l) { fill(bx, l.c, 0, Bt - (l.d + l.t / 2) * u, W, l.t * u); });
      (spec.frames || []).forEach(function (f) { fill(bx, f.c, f.l * u, Bt - (f.b + f.k) * u, W - (f.l + f.r) * u, f.k * u); });
      out.push({ canvas: bot, left: 0, top: H - Bt, w: bot.width, h: bot.height });
    }
    /* côtés */
    if (sideExt) {
      var lc = newCanvas(S, H), rc = newCanvas(S, H), lx = lc.getContext('2d'), rx = rc.getContext('2d');
      (spec.frames || []).forEach(function (f) {
        fill(lx, f.c, f.l * u, f.t * u, f.k * u, H - (f.t + f.b) * u);
        fill(rx, f.c, S - (f.r + f.k) * u, f.t * u, f.k * u, H - (f.t + f.b) * u);
      });
      (spec.sideLines || []).forEach(function (s) {
        fill(lx, s.c, s.x * u, s.y0 * u, s.k * u, H - (s.y0 + s.d1) * u);
        fill(rx, s.c, S - (s.x + s.k) * u, s.y0 * u, s.k * u, H - (s.y0 + s.d1) * u);
      });
      out.push({ canvas: lc, left: 0, top: 0, w: lc.width, h: lc.height }, { canvas: rc, left: W - S, top: 0, w: rc.width, h: rc.height });
    }
    return out;
  }
  /* Titre INSTANT CÉLESTE : centré à cy, sur une largeur w (millièmes de la largeur), espacement des lettres constant. */
  function titleText(ctx, W, t, u) {
    var text = 'INSTANT CÉLESTE', ls = 0.1, probe = newCanvas(1, 1).getContext('2d');
    probe.font = '600 100px ' + FONT; setLS(probe, ls * 100);
    var size = 100 * (t.w * u) / glyphWidth(probe, text, ls * 100);
    ctx.font = '600 ' + size + 'px ' + FONT; ctx.fillStyle = t.c; ctx.textBaseline = 'alphabetic'; setLS(ctx, ls * size);
    var m = ctx.measureText('H');
    drawRun(ctx, text, W / 2 - glyphWidth(ctx, text, ls * size) / 2, t.cy * u + (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2, ls * size);
  }
  /* ---------- Les orbes de vie : même mise en page que .orbes-poster ---------- */
  function orbeElements(ctx, W, H, f, showTitle, title) {
    var els = [];
    if (showTitle) els.push({ key: 'title', text: title, size: 11.5 * W / 100, weight: 500, style: 'normal', spacing: 0.06, comp: true, lh: 1.1, yc: 0.095 * H });
    els.push({ key: 'name', text: f.prenom, size: clamp(150 / Math.max(1, f.prenom.length), 9, 21) * W / 100, weight: 500, style: 'normal', spacing: 0, comp: true, lh: 1, yc: 0.78 * H });
    els.push({ key: 'date', text: f.dateLine, size: clamp(190 / Math.max(1, f.dateLine.length), 3.4, 4.9) * W / 100, weight: 600, style: 'normal', spacing: 0.02, comp: false, lh: 1.1, yc: 0.874 * H });
    if (f.phrase) els.push({ key: 'phrase', text: f.phrase, size: 4.4 * W / 100, weight: 600, style: 'italic', spacing: 0, comp: true, lh: 1.2, yc: 0.922 * H, wrapW: 0.84 * W });
    els.forEach(function (e) {
      ctx.font = fontStr(e); setLS(ctx, e.spacing * e.size);
      var m = ctx.measureText('Hgé'), asc = m.fontBoundingBoxAscent, desc = m.fontBoundingBoxDescent, lineH = e.lh * e.size;
      e.lines = e.wrapW ? wrap(ctx, e.text, e.wrapW) : [e.text];
      e.lineH = lineH; e.blockH = lineH * e.lines.length; e.top = e.yc - e.blockH / 2; e.baseOffset = (lineH - (asc + desc)) / 2 + asc;
      e.ls = e.spacing * e.size;
      e.widths = e.lines.map(function (l) { return glyphWidth(ctx, l, e.ls); });
      /* sans padding de compensation, le texte (espacement final compris) est centré : décalage d'un demi-espacement */
      e.shift = e.comp ? 0 : -e.ls / 2;
    });
    return els;
  }
  function orbeLayers(W, H, f, design, showTitle) {
    var d = DESIGNS[design], out = [], els = orbeElements(newCanvas(1, 1).getContext('2d'), W, H, f, showTitle, d.title);
    /* 1. dégradé du bas, propre à chaque orbe */
    var a = d.veil.rgba, col = function (al) { return 'rgba(' + a[0] + ',' + a[1] + ',' + a[2] + ',' + al + ')'; };
    out.push(gradientLayer(W, 0, H, [[0, col(0)], [d.veil.from, col(0)], [1, col(a[3])]]));
    /* 2. halos lumineux : calque basse définition (c'est du flou) étiré par le relais */
    var s = Math.min(1, 1800 / W), gc = newCanvas(W * s, H * s), g = gc.getContext('2d'), OFF = gc.width * 3;
    g.textBaseline = 'alphabetic'; g.fillStyle = '#000';
    els.forEach(function (e) {
      g.font = e.style + ' ' + e.weight + ' ' + (e.size * s) + 'px ' + FONT; setLS(g, e.ls * s);
      for (var si = d.glow.length - 1; si >= 0; si--) {
        var sh = d.glow[si];
        g.shadowColor = sh[3]; g.shadowBlur = sh[2] * e.size * s; g.shadowOffsetX = OFF + sh[0] * e.size * s; g.shadowOffsetY = sh[1] * e.size * s;
        e.lines.forEach(function (line, i) {
          var x = W / 2 + e.shift - e.widths[i] / 2;
          drawRun(g, line, x * s - OFF, (e.top + i * e.lineH + e.baseOffset) * s, e.ls * s);
        });
      }
    });
    out.push({ canvas: gc, left: 0, top: 0, w: W, h: H });
    /* 3. texte net, bandes serrées */
    els.forEach(function (e) {
      var maxLine = Math.max.apply(null, e.widths), pad = Math.ceil(e.size * 0.15), bw = Math.min(W, Math.ceil(maxLine + e.size * 0.4)), bh = Math.ceil(e.blockH + pad * 2);
      var left = Math.round(W / 2 + e.shift - bw / 2), top = Math.round(e.top - pad), cv = newCanvas(bw, bh), c = cv.getContext('2d');
      c.textBaseline = 'alphabetic'; c.font = fontStr(e); c.fillStyle = d.color; setLS(c, e.ls);
      e.lines.forEach(function (line, i) { drawRun(c, line, bw / 2 - e.widths[i] / 2, pad + i * e.lineH + e.baseOffset, e.ls); });
      out.push({ canvas: cv, left: Math.max(0, left), top: Math.max(0, top), w: bw, h: bh });
    });
    return out;
  }

  /* ---------- API ---------- */
  function info(design, formatId) {
    var f = fmt(formatId), scale = Math.max(f.pxW / MASTER_W, f.pxH / MASTER_H);
    return { W: f.pxW, H: f.pxH, label: f.label, dpiEffective: Math.round(300 / Math.max(1, scale)), upscaled: scale > 1.001 };
  }
  /* Construit les calques pour une largeur donnée (aperçu ou impression). */
  function build(design, formatId, raw, W, opts) {
    opts = opts || {};
    var d = DESIGNS[design], f = fmt(formatId), H = Math.round(W * f.pxH / f.pxW), fields = formatFields(raw, opts.locale, design);
    var layers = d.kind === 'orbe' ? orbeLayers(W, H, fields, design, opts.showTitle !== false) : celesteLayers(W, H, fields, design);
    return { W: W, H: H, layers: layers, design: design, format: formatId };
  }
  /* Aperçu : base (fichier d'origine réduit, recadré en « cover ») + calques. */
  function compose(canvas, baseImg, built) {
    var W = built.W, H = built.H; canvas.width = W; canvas.height = H;
    var x = canvas.getContext('2d'), s = Math.max(W / baseImg.naturalWidth, H / baseImg.naturalHeight);
    var dw = baseImg.naturalWidth * s, dh = baseImg.naturalHeight * s;
    x.imageSmoothingQuality = 'high'; x.drawImage(baseImg, (W - dw) / 2, (H - dh) / 2, dw, dh);
    built.layers.forEach(function (l) { x.drawImage(l.canvas, l.left, l.top, l.w, l.h); });
  }

  function fontsReady(urls) {
    if (!window.FontFace || !document.fonts) return Promise.resolve();
    var faces = [
      new FontFace('Cormorant Lining', 'url(' + urls.normal + ')', { style: 'normal', weight: '300 700' }),
      new FontFace('Cormorant Lining', 'url(' + urls.italic + ')', { style: 'italic', weight: '300 700' })
    ];
    return Promise.all(faces.map(function (f) { return f.load(); })).then(function (loaded) {
      loaded.forEach(function (f) { document.fonts.add(f); });
      return Promise.all(['400', '500', '600'].map(function (w) { return document.fonts.load(w + ' 100px "Cormorant Lining"'); }).concat([document.fonts.load('italic 600 100px "Cormorant Lining"')]));
    });
  }

  window.CelestiarHD = { DESIGNS: DESIGNS, formatFields: formatFields, build: build, compose: compose, info: info, fontsReady: fontsReady, MASTER_W: MASTER_W, MASTER_H: MASTER_H };
})();
